import { render } from "./DocumentationCellRenderer.vue?vue&type=template&id=07860eb0"
import script from "./DocumentationCellRenderer.vue?vue&type=script&lang=js"
export * from "./DocumentationCellRenderer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\victo\\Documents\\Projects\\RawData\\product-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__